// 获取 ul 的 list-style-type 属性值
export const getListStyleType = (node) => {
    const listStyleType = node.getAttribute('data-list-style-type') ||
        node.style.listStyleType ||
        node.getAttribute('type');
    return listStyleType === 'none' ? '' : listStyleType;
};
//# sourceMappingURL=util.js.map